<h3 mat-dialog-title>
  Asset:
  {{data.asset.name}}
  <br>
    <small class="text small-text">
      Code: {{data.asset.code}} |
      Type: {{ data.asset.assetTypeName }} |
      Description: {{ data.asset.description }}
    </small>
    <br>
      <small class="text small-text">

      </small>
    </h3>
    <div mat-dialog-content>
      <!-- <form class="asset-form" (ngSubmit)="onSubmit($event)"> -->
      @if (!targetCustomer) {
        <mat-label disabled>Please select </mat-label>
      }
      @if (targetCustomer) {
        <mat-label mat-dialog-title>Will be assigned to:
        </mat-label>
      }
      <mat-form-field>
        <mat-select matInput placeholder="Customer" required [(ngModel)]="assetsToAssign" name="basicName"
          (selectionChange)="selectedCustomer($event)">
          @for (available of customers | sort: 'basicName'; track available) {
            <mat-option [value]="available">
              {{ available.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <br>
        @if (targetCustomer && isScout) {
          <div>
            <mat-label mat-dialog-title>Scout created as:
            </mat-label>
            <input style="max-width: 70%" placeholder="{{name}}" matInput [(ngModel)]="name"
              [ngModelOptions]="{standalone: true}" />
            <hr />
            <mat-slide-toggle [(ngModel)]="doScoutSensor">
              Send Attached Assets ({{doScoutSensor}})
            </mat-slide-toggle>
          </div>
        }
        <hr />
        <button mat-raised-button type="submit" [disabled]="!targetCustomer" color="primary" style="max-width: min-content"
          (click)="onSubmit($event)">
          Xfer
        </button>
      <!-- </form> -->
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button class="close" (click)="onNoClick()" color="warn" style="max-width: min-content">
        Cancel
      </button>
    </div>